

import * as THREE from 'three';
import { MojiPointsUtil } from './utils/MojiPointsUtil';
import { MojiDot } from './MojiDot';
import { MojisDotRender } from './MojisDotRender';
import { Point3 } from '../data/Params';
import { ConnectingDotsRender } from './ConnectingDotsRender';

export class Moji extends THREE.Object3D{


    basePoints:Point3[];
    dots        :MojiDot[];
    enabledDots :MojiDot[]=[]
    counter:number=0;
    dotRenderer:MojisDotRender;
    connecting:ConnectingDotsRender;
    distance:number = 0;
    numDots:number = 0;
    moji:string="";

    constructor(
        moji:string,
        xx:number,
        yy:number,
        ratio:number,
        numRatio:number=10
    ){
        super();
        this.moji = moji;
        this.position.x=200*xx;
        this.position.y=200*yy;
        this.position.z=0;

        this.connecting = ConnectingDotsRender.getInstance();
        this.dotRenderer = MojisDotRender.getInstance();
        this.basePoints = [];
        
        this.basePoints     = MojiPointsUtil.getPoints(moji);
        this.distance       = MojiPointsUtil.getDistance(moji,this.basePoints);
        this.dots = [];
        
        //利用するドットの数
        this.numDots = Math.floor( this.distance*numRatio );

        let startNum = ratio/this.numDots;

        //this.enabledDots=[];
        for(let i=0;i<this.numDots;i++){
            let d = new MojiDot(0,0,0,1,startNum+i/this.numDots);
            d.index=i;
            d.enabled=true;
            this.dots.push(d);
        }

    }

    
    setNum(wari:number){
        
        for(let i=0;i<this.dots.length;i++){
            this.dots[i].enabled = i%wari==0 ? true : false;
        }
        this.updateEnabledDots();
        
    }

    addVelocity(){

        for(let i=0;i<this.dots.length;i++){
            this.dots[i].velocity = 0.007;
        }

    }

    updateEnabledDots(){
        
        this.enabledDots=[];

        for(let i=0;i<this.dots.length;i++){
            if( this.dots[i].enabled ){
                this.enabledDots.push(this.dots[i]);
            }
        }

    }

    public SetAllEnabled(b:boolean){
        for(let i=0;i<this.dots.length;i++){
            this.dots[i].enabled = b;
        }
    }

    update(){

        let past = {
            x:0,y:0,z:0
        };

        let firtDot:MojiDot = null;
        this.enabledDots=[];

        for(let i=0;i<this.dots.length;i++){

            let dot = this.dots[i];
            let p = MojiPointsUtil.getPoint(
                1-dot.ratio,
                this.basePoints
            );

            dot.x = 200*(p.x);
            dot.y = 200*(p.y);
            dot.z = 200*(p.z);
            dot.v.x = 200*(p.x);
            dot.v.y = 200*(p.y);
            dot.v.z = 200*(p.z);

            dot.v = this.localToWorld(dot.v);

            if(dot.enabled){
                //ここを調整する            
                this.dotRenderer.setPoint(
                    dot.v.x,dot.v.y,dot.v.z,dot.scale
                );
                this.enabledDots.push(dot);
            }else{
                this.dotRenderer.setPoint(
                    999,999,999,dot.scale
                );
            }

        }

        for(let i=0;i<this.dots.length;i++){
            let dot = this.dots[i];
            dot.update();
        }

    }

}